import React from 'react'
import type { EventGQL } from '../../../Api'
import { QuartersTop, QuartersBottom } from './index'
import { SemisTop, SemisBottom } from './index'
import { GamesOuter } from './styles'

type MatchupProps = {
  events: EventGQL[]
}

export const GamesCon: React.FC<React.PropsWithChildren<MatchupProps>> = ({ events }) => {
  return (
    <GamesOuter>
      {events.length > 1 && (
        <>
          <div className='gamesRow'>
            <QuartersTop events={events} />
            <SemisTop events={events} />
          </div>
          <div className='gamesRow'>
            <QuartersBottom events={events} />
            <SemisBottom events={events} />
          </div>
        </>
      )}
    </GamesOuter>
  )
}
